
<footer *ngIf="!(isFooterHide | async)" [ngClass]="{
    'footer-home-page': isHomePage
  }">
        <div class="container">
            <div class="row">
                <div class="text-center m-auto footer-main">
	                <span class="footer-txt">Copyright {{currentYear | date : 'yyyy'}}</span>
                    <a (click)="openPrivacy()" class="footer-txt font-weight-bold">Privacy</a>
                </div>
            </div>
        </div>
    </footer>  
    
    
    <dmv-privacy (closePopup)="closePrivacy()" [privacyPolicy]="(megStoreService.configurationsData$ | async)?.megConfig?.privacyPolicy" *ngIf="isPrivacyOpen"></dmv-privacy>